import PageRoutes from '../../assets/consts/PageRoutes';
import { Navigate } from 'react-router-dom';

export default Object.freeze([
    {
        path: PageRoutes.appHome,
        caseSensitive: true,
        lazy: () => import('components/mainLayout/MainLayout'),
        children: [
            { index: true, element: <Navigate to={PageRoutes.consent} /> },
            {
                path: PageRoutes.contract,
                caseSensitive: true,
                children: [
                    { index: true, element: <Navigate to={PageRoutes.consent} /> },
                    {path: PageRoutes.consent, caseSensitive: true, lazy: () => import('../../pages/consent')},
                    {path: PageRoutes.otp, caseSensitive: true, lazy: () => import('../../pages/otp')},
                    {path: PageRoutes.thankPage, caseSensitive: true, lazy: () => import('../../pages/thankPage')},
                    {path: PageRoutes.errorPage, caseSensitive: true, lazy: () => import('../../pages/errorPage')},
                    {path: PageRoutes.expiredLink, caseSensitive: true, lazy: () => import('../../pages/expired')},
                    {path: PageRoutes.skippedPage, caseSensitive: true, lazy: () => import('../../pages/skipped')},
                    {path: PageRoutes.resetPage, caseSensitive: true, lazy: () => import('../../pages/reset')},
                    {path: PageRoutes.signDocument, caseSensitive: true, lazy: () => import('../../pages/signDocument')},
                    {path: PageRoutes.downloadDocument, caseSensitive: true, lazy: () => import('../../pages/downloadDocument')},
                ],
            },
        ],
    },
]);
